import * as React from 'react';
import { SubHeading } from '../Typography/sub-heading';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export const WidgetContainer = _ref => {
  let {
    heading,
    children,
    commandBar,
    commandBarPosition = 'bottom',
    headingLevel = 1,
    required
  } = _ref;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [commandBarPosition === 'top' && commandBar, /*#__PURE__*/_jsxs(SubHeading, {
      headingLevel: headingLevel,
      children: [heading, ' ', required && /*#__PURE__*/_jsx("span", {
        style: {
          color: 'rgb(164, 38, 44)'
        },
        children: "*"
      })]
    }), children, commandBarPosition === 'bottom' && commandBar]
  });
};